import { Box, TextField, Typography, Divider, Grid, MenuItem, Button, Snackbar, Alert } from "@mui/material";
import { useState } from "react";
import { cities } from "../../../data/cities.js";
import { useRegisterEmployeeMutation } from "../../../redux/slices/admin/workers/newEmployeeSlince.js";
import "../../../styles/admin.css/workers-css/new-employees.css";

export default function NewEmployee() {
  const [registerEmployee] = useRegisterEmployeeMutation();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    address1: "",
    address2: "",
    city: "",
    panelEmail: "",
    password: ""
  });

  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState({ open: false, severity: "success", message: "" });

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const lettersOnly = /^[a-zA-ZəöüşçığƏÖÜŞÇİ\s]*$/;
  const lettersNumbers = /^[a-zA-Z0-9əöüşçığƏÖÜŞÇİ.\s]*$/;
  const numbersOnly = /^\d{0,9}$/;


  const handleSubmit = async () => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (!formData[key]) {
        newErrors[key] = "Bu sahə boş ola bilməz";
      }
    });

    if (formData.panelEmail && !emailRegex.test(formData.panelEmail)) {
      newErrors.panelEmail = "Email düzgün deyil";
    }
    if (formData.password && formData.password.length < 6) {
      newErrors.password = "Şifrə ən azı 6 simvol olmalıdır";
    }
    if (formData.phone && formData.phone.length < 9) {
      newErrors.phone = "Əlaqə nömrəsi ən azı 9 rəqəm olmalıdır";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.panelEmail,
      phonenumber: formData.phone,
      password: formData.password,
      adress1: formData.address1,
      adress2: formData.address2,
      city: formData.city
    };

    try {
      await registerEmployee(payload).unwrap();
      setToast({ open: true, severity: "success", message: "Əlavə edildi" });

      setToast({ open: true, severity: "success", message: "Əlavə edildi" });
      setFormData({
        firstName: "",
        lastName: "",
        phone: "",
        address1: "",
        address2: "",
        city: "",
        panelEmail: "",
        password: ""
      });
      setErrors({});
    } catch (err) {
      console.error(err);

      if (err.status === 400 && err.data === "Bele istifadeci var") {
        setToast({ open: true, severity: "info", message: "İstifadəçi artıq mövcuddur" });
      } else {
        setToast({ open: true, severity: "error", message: "Xəta baş verdi" });
      }
    }
  };

  const handleCloseToast = () => {
    setToast({ ...toast, open: false });
  };

  return (
    <Box className="profile-container">
      <Typography className="profile-title">Şəxsi məlumat</Typography>
      <Divider className="profile-divider" />

      <Grid container spacing={0}>
        <Grid item xs style={{ flex: 1, paddingRight: 8 }}>
          <TextField
            fullWidth
            label="Ad"
            value={formData.firstName}
            error={!!errors.firstName}
            helperText={errors.firstName}
            onChange={(e) => {
              if (lettersOnly.test(e.target.value) || e.target.value === "") {
                setFormData({ ...formData, firstName: e.target.value });
              }
            }}
          />
        </Grid>
        <Grid item xs style={{ flex: 1, paddingLeft: 8 }}>
          <TextField
            fullWidth
            label="Soyad"
            value={formData.lastName}
            error={!!errors.lastName}
            helperText={errors.lastName}
            onChange={(e) => {
              if (lettersOnly.test(e.target.value) || e.target.value === "") {
                setFormData({ ...formData, lastName: e.target.value });
              }
            }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={0} style={{ marginTop: 16 }}>

        <Grid item xs style={{ flex: 1, paddingLeft: 0 }}>
          <TextField
            fullWidth
            label="Əlaqə nömrəsi"
            value={formData.phone}
            error={!!errors.phone}
            helperText={errors.phone}
            onChange={(e) => {
              if (numbersOnly.test(e.target.value) || e.target.value === "") {
                setFormData({ ...formData, phone: e.target.value });
              }
            }}
            InputProps={{
              startAdornment: (
                <span style={{ marginRight: 4, color: "#545A61" }}>+994</span>
              )
            }}
          />
        </Grid>
        <Grid item xs style={{ flex: 1, paddingLeft: 16 }}>
          <TextField
            select
            label="Şəhər"
            fullWidth
            value={formData.city}
            error={!!errors.city}
            helperText={errors.city}
            onChange={(e) => setFormData({ ...formData, city: e.target.value })}
            SelectProps={{
              MenuProps: {
                PaperProps: { style: { maxHeight: 250, width: 250 } }
              }
            }}
          >
            {cities.map((c, i) => (
              <MenuItem key={i} value={c}>{c}</MenuItem>
            ))}
          </TextField>

        </Grid>


      </Grid>

      <TextField
        fullWidth
        label="Ünvan"
        className="input-full"
        style={{ marginTop: 16 }}
        value={formData.address1}
        error={!!errors.address1}
        helperText={errors.address1}
        onChange={(e) => {
          if (lettersNumbers.test(e.target.value) || e.target.value === "") {
            setFormData({ ...formData, address1: e.target.value });
          }
        }}
      />
      <TextField
        fullWidth
        label="Ünvan 2"
        className="input-full"
        style={{ marginTop: 16 }}
        value={formData.address2}
        error={!!errors.address2}
        helperText={errors.address2}
        onChange={(e) => {
          if (lettersNumbers.test(e.target.value) || e.target.value === "") {
            setFormData({ ...formData, address2: e.target.value });
          }
        }}
      />



      <Typography className="profile-title" style={{ marginTop: 24 }}>Panelə giriş</Typography>
      <Divider className="profile-divider" />

      <Grid container spacing={0}>
        <Grid item xs style={{ flex: 1, paddingRight: 8 }}>
          <TextField
            fullWidth
            label="E-poçt"
            value={formData.panelEmail}
            error={!!errors.panelEmail}
            helperText={errors.panelEmail}
            onChange={(e) => {
              if (/^[a-zA-Z0-9@._-]*$/.test(e.target.value) || e.target.value === "") {
                setFormData({ ...formData, panelEmail: e.target.value });
              }
            }}
          />
        </Grid>
        <Grid item xs style={{ flex: 1, paddingLeft: 8 }}>
          <TextField
            fullWidth
            type="password"
            label="Şifrə"
            value={formData.password}
            error={!!errors.password}
            helperText={errors.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
          />
        </Grid>
      </Grid>

      <Box style={{ marginTop: 24, display: "flex", justifyContent: "flex-end", marginBottom: 100 }}>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Əlavə et
        </Button>
      </Box>

      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%' }}>
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
